module.exports = __webpack_public_path__ + "img/ss.1378c215.png";